import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { API } from "../utils/api";

export default function TrainerLogin() {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/trainer/auth/login`, { phone, password });
      localStorage.setItem("trainer_token", res.data.token);
      localStorage.setItem("trainer_id", res.data.trainer_id);
      localStorage.setItem("trainer_name", res.data.name);
      navigate("/trainer/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-black text-[#FFB612] tracking-tight">NBC</h1>
          <p className="text-white/60 text-sm mt-1">Trainer Portal</p>
        </div>
        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="text-white/60 text-xs uppercase tracking-widest mb-1 block">Phone Number</label>
            <input
              data-testid="trainer-login-phone"
              type="tel"
              value={phone}
              onChange={e => setPhone(e.target.value)}
              placeholder="(614) 000-0000"
              required
              className="w-full bg-white/5 border border-white/10 text-white px-4 py-3 rounded focus:outline-none focus:border-[#FFB612]"
            />
          </div>
          <div>
            <label className="text-white/60 text-xs uppercase tracking-widest mb-1 block">Password</label>
            <input
              data-testid="trainer-login-password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••"
              required
              className="w-full bg-white/5 border border-white/10 text-white px-4 py-3 rounded focus:outline-none focus:border-[#FFB612]"
            />
          </div>
          <button
            data-testid="trainer-login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-[#FFB612] text-black font-black py-3 rounded hover:bg-[#E5A00D] transition-colors disabled:opacity-50"
          >
            {loading ? "Logging in…" : "Continue to Dashboard"}
          </button>
        </form>
      </div>
    </div>
  );
}
